import React from 'react';
import styled from 'styled-components';
import DeviceSelection from '../../../DeviceSelection';
import CameraIcon from '../../../common/Icons/Camera';
import { useTwilioUserMediaContext } from '../../../../customer-call-sdk';
import Messages from '../../../../config/messages.constants';
import LocalVideo from '../../../LocalVideo';
import { localTrackToMediaStream } from '../../../../utils/local-track.util';

const StyledLocalVideo = styled.div`
    display: flex;
    justify-content: flex-end;

    .local-video {
        width: 220px;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
`;
const defaultCamera: MediaDeviceInfo = {
    deviceId: 'default',
    kind: 'audiooutput',
    label: 'No Camera available',
    groupId: '',
    toJSON: () => {},
};

/**
 * Camera selection list item
 */
const CameraSelection: React.FC = () => {
    const {
        cameras,
        videoTracks,
        videoDeviceId,
        isVideoBlocked,
        isRequestingVideoPermission,
        startMedia,
    } = useTwilioUserMediaContext();
    const selectedCamera = cameras.find((camera) => camera.deviceId === videoDeviceId) || null;
    const videoTrack = videoTracks[0];
    const cameraUnavailable = cameras.length === 0;
    /**
     * Handle select change
     *
     * @param {MediaDeviceInfo} value selected camera
     */
    const handleChange = (value: MediaDeviceInfo) => {
        startMedia({ videoDeviceId: value.deviceId, type: 'exact' });
    };

    return (
        <>
            <DeviceSelection
                icon={CameraIcon}
                primaryText={Messages.DEVICE_SETTING.CAMERA.TITLE}
                value={cameraUnavailable ? defaultCamera : selectedCamera}
                options={cameraUnavailable ? [defaultCamera] : cameras}
                onChange={handleChange}
                disabled={isVideoBlocked || isRequestingVideoPermission || cameraUnavailable}
                data-testid="camera-device-setting"
                id="camera-device-setting"
                ariaLabel="camera options"
            />
            {videoTrack && (
                <StyledLocalVideo>
                    <LocalVideo
                        mediaStream={localTrackToMediaStream(videoTrack)}
                        className="local-video"
                    />
                </StyledLocalVideo>
            )}
        </>
    );
};

export default CameraSelection;
